import Bangkeo from "@/components/client/Bangkeo";
import HeaderFixture from "@/components/client/HeaderFixture";

const BangkeoMain = ({league}) => {
  return (
    <>
      <div className="mt-4">
        <HeaderFixture />
      </div>
      <div className="mt-4">
        <Bangkeo leagueAttr={league}/>
      </div>
    </>
  );
};

export default BangkeoMain;